/**
 * Hard refresh utility - TypeScript replacement for window.Homebase.RailsReactBridge.hardRefresh()
 *
 * This function shows the global loader and performs a full page navigation/reload,
 * matching the exact behavior of the bridge.js hardRefresh method.
 */

import { showGlobalLoader } from './globalLoader';

export const hardRefresh = (route?: string) => {
  showGlobalLoader();
  window.location.href = route || window.location.pathname;
};
